module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row,
      "label-width": "140px"
    }
  }, [_c('div', {
    staticClass: "kaoji-title"
  }, [_vm._v(_vm._s(_vm.row.danwei) + _vm._s(_vm.row.clubleixing))]), _vm._v(" "), _c('div', {
    staticClass: "kaoji-mine"
  }, [_vm._v("我的身份：" + _vm._s(_vm.row.clubleixing) + _vm._s(_vm.row.user_type))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "基本资料",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailBase')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "成员信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailCommunity')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "先进申报",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailShenbao')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailKaoji')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "积分情况",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailScore')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "星级俱乐部升级",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailDanwei')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "风采展示",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailFengcai')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "数据导出",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-188d0156","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetail.vue
// module id = 1391
// module chunks = 0